// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import confirmDialogReducer from './slices/confirmDialog';
import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
import mailReducer from './slices/mail';
import userReducer from './slices/user';
import cartReducer from './slices/cart';
import kanbanReducer from './slices/kanban';
import ticketBoardReducer from './slices/ticketBoard';
import menuReducer from './slices/menu';
import loadingReducer from './slices/loading';
import loadingCursorReducer from './slices/loadingCursor';
import notificationtReducer from './slices/notification';
import emailReducer from './slices/emails';
import storeReducer from './slices/stores';
import ticketTypesReducer from './slices/ticketTypes';


// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'berry-'
        },
        cartReducer
    ),
    kanban: kanbanReducer,
    ticketBoard: ticketBoardReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    calendar: calendarReducer,
    mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    loading: loadingReducer,
    loadingCursor: loadingCursorReducer,
    notification: notificationtReducer,
    email: emailReducer,
    stores: storeReducer,
    ticketTypes: ticketTypesReducer,
    confirmDialog: confirmDialogReducer,
});

export default reducer;
